import { getSelectedFormContent } from 'modules/mobileApps/components/utils';
import {
  IntegrationFormField,
  useIntegrationFormContext,
} from 'modules/mobileApps/context/integrationForm';
import { IntegrationAuthType } from 'modules/mobileApps/types';
import { GroupLabel } from '../ApnsIntegrationForm.styled';
import { FirebaseIntegrationForm } from '../FirebaseIntegrationForm';
import { P12FormPart, P8FormPart, PEMFormPart } from './';

export const AuthDetails = () => {
  const { watch } = useIntegrationFormContext();
  const authType = watch(IntegrationFormField.authType);

  const selectedContent = getSelectedFormContent(authType);
  if (!selectedContent) return;

  const groupLabel = `Configure your ${selectedContent.name} ${
    selectedContent.id === IntegrationAuthType.FIREBASE_JSON ? 'integration' : ''
  }`;

  const detailsViews = {
    [IntegrationAuthType.P8]: <P8FormPart />,
    [IntegrationAuthType.P12]: <P12FormPart />,
    [IntegrationAuthType.PEM]: <PEMFormPart />,
    [IntegrationAuthType.FIREBASE]: <FirebaseIntegrationForm />,
    [IntegrationAuthType.FIREBASE_JSON]: <FirebaseIntegrationForm />,
  };

  return (
    <>
      <GroupLabel data-test="auth-details-group-label">{groupLabel}</GroupLabel>
      {authType && detailsViews[authType]}
    </>
  );
};
